import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const login = async (User) => {
  const { data } = await axios.post(`${baseUrl}/plutusUsers/login`, User);
  return data;
};

const getMenuList = async (param) => {
  const { data } = await axios.get(`${baseUrl}/plutusUsers/menu`, {
    params: param,
  });
  return data;
};

const logout = async (User) => {
  const { data } = await axios.post(`${baseUrl}/plutusUsers/logout`, User);
  return data;
};

const userAuthApi = {
  login,
  getMenuList,
  logout,
};

export default userAuthApi;
